import { Record, RecordOf } from 'immutable';

import { NOTIFY_ABOUT_CHANGED_LANG, NotifyAboutChangedLang } from 'app/lang';
import {
  createEntitiesReducer,
  RecordOfBettingEntitiesState,
  SSRBettingEntitiesState,
} from 'app/lib/betting/betting-entities';
import {
  APPLY_MATCHES, type ApplyMatches,
  SUBSCRIBE_TO_MATCHES, type SubscribeToMatches,
  UNSUBSCRIBE_FROM_MATCHES, type UnsubscribeFromMatches,
} from 'app/lib/signalr/redux/actions/subscribe-to-matches';
import { INIT_ACTION } from 'app/redux/actions/init';
import {
  SET_PREMATCH_GRID_ORDER_KEY,
  SET_PREMATCH_GRID_STAKE_TYPES,
} from 'app/redux/betting-presentation/grid/actions';
import createGridReducer from 'app/redux/betting-presentation/grid/reducers';
import { TRANSFORM_SSR_STATE, TransformSSRState } from 'app/redux/ssrState';

import { MATCH_OF_THE_DAY_TOPIC } from './actions';

// ---

// TODO: https://jira.tennisi.it/browse/SITE-887
//  process.env.SERVER ? {
//   TRIGGER_ACTION: FETCH_MATCH_OF_THE_DAY_SUCCESS,
//   REQUEST_ACTION: FETCH_MATCH_OF_THE_DAY_REQUEST,
//   FAILURE_ACTION: FETCH_MATCH_OF_THE_DAY_FAILURE,
//   CLEANUP_ACTION: UNSUBSCRIBE_MATCH_OF_THE_DAY,
// } : {
//   TRIGGER_ACTION: APPLY_MATCHES,
//   REQUEST_ACTION: SUBSCRIBE_TO_MATCHES,
//   CLEANUP_ACTION: UNSUBSCRIBE_FROM_MATCHES,
// }

const reduceGrid = createEntitiesReducer({
  TRIGGER_ACTION: APPLY_MATCHES,
  REQUEST_ACTION: SUBSCRIBE_TO_MATCHES,
  CLEANUP_ACTION: UNSUBSCRIBE_FROM_MATCHES,
});

const reducePresentationGrid = createGridReducer({
  APPLY_STATE: APPLY_MATCHES, // TODO: process.env.SERVER ? FETCH_MATCH_OF_THE_DAY_SUCCESS : APPLY_MATCHES
  SET_GRID_ORDER_KEY: SET_PREMATCH_GRID_ORDER_KEY,
  SET_GRID_STAKE_TYPES: SET_PREMATCH_GRID_STAKE_TYPES,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PresentationState = any;

type MatchOfTheDayState = {
  entities: RecordOfBettingEntitiesState;
  grid: PresentationState;
};

export type RecordOfMatchOfTheDayState = RecordOf<MatchOfTheDayState>;

const initialState = Record<MatchOfTheDayState>({
  entities: reduceGrid(undefined, INIT_ACTION),
  grid: reducePresentationGrid(undefined, 'matchoftheday', INIT_ACTION, undefined),
});

// ---

type ApplyEntities =
  | ApplyMatches
  | SubscribeToMatches
  | UnsubscribeFromMatches
  | NotifyAboutChangedLang;
// TODO https://jira.tennisi.it/browse/SITE-887
// | FetchMatchOfTheDayRequest
// | FetchMatchOfTheDaySuccess
// | FetchMatchOfTheDayFailure

type MatchOfTheDayActions =
  | TransformSSRState<SSRBettingEntitiesState>
  | ApplyEntities;

function applyEntities(
  state: RecordOfMatchOfTheDayState,
  action: ApplyEntities,
): RecordOfMatchOfTheDayState {
  state = state.update('entities', (state) => reduceGrid(state, action));
  state = state.update('grid', (currentPresentation) => {
    return reducePresentationGrid(currentPresentation, 'matchoftheday', action, state.get('entities'));
  });

  return state;
}

export default function (
  state = initialState(),
  action: MatchOfTheDayActions,
): RecordOfMatchOfTheDayState {
  switch (action.type) {
    // TODO https://jira.tennisi.it/browse/SITE-887
    // case FETCH_MATCH_OF_THE_DAY_REQUEST:
    // case FETCH_MATCH_OF_THE_DAY_SUCCESS:
    // case FETCH_MATCH_OF_THE_DAY_FAILURE:
    case APPLY_MATCHES:
    case SUBSCRIBE_TO_MATCHES:
    case UNSUBSCRIBE_FROM_MATCHES:
      if (!action.payload.topic.endsWith(MATCH_OF_THE_DAY_TOPIC)) {
        return state;
      }

      return applyEntities(state, action);

    case NOTIFY_ABOUT_CHANGED_LANG:
      return applyEntities(state, action);

    case TRANSFORM_SSR_STATE: {
      if (Record.isRecord(state)) {
        return state; // already transformed (initial state case)
      }

      const plainState = state as unknown as {
        entities: SSRBettingEntitiesState;
        grid: PresentationState;
      };

      const gridEntities = reduceGrid(plainState.entities, action);

      return initialState({
        entities: gridEntities,
        grid: reducePresentationGrid(plainState.grid, 'matchoftheday', action, gridEntities),
      });
    }

    default:
      return state;
  }
}
